import { CREATE_INVOICE_TXN, VOID_INVOICE_TXN, GET_INVOICE_TXNS } from './invoiceTxn.type';

export const createInvoiceTxn = (invoiceId, body) => ({
    type: CREATE_INVOICE_TXN,
    payload: { invoiceId, body },
});

export const voidInvoiceTxn = (txnId, body, invoiceId, reqParams) => ({
    type: VOID_INVOICE_TXN,
    payload: { txnId, body, invoiceId, reqParams },
});

export const getInvoiceTxns = (invoiceId, params) => ({
    type: GET_INVOICE_TXNS,
    payload: { invoiceId, params },
});
